import React from "react";
import Conversation from "../../components/conversations/Conversations";

function Conversations() {
  return <Conversation />;
}

export default Conversations;
